import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/onboarding.css";
import "../../../../assets/css/stepper.css";
import {
  callToast,
  showErrorMessages,
} from "../../../../../src/services/utilityFunctions.js";
import { getLocalStorageData } from "../../../../../src/services/axiosComponent";
import Select from "react-select";
import { selectStyle } from "../../../../services/constant";
import { closeModal } from "../../../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  addExaminationSeriesSubject,
  updateExaminationSeriesSubject,
  getExaminationSeriesSubjectDetails,
  getExamainationTemplatesList,
} from "../../../../services/Users-services.js";

const AddSeriesSubjectForm = (props) => {
  const { refresh, navigate } = props;
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modal);

  const [data, setData] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(modal.isEditing);

  // Options state
  const [examinationOptions, setExaminationOptions] = useState([]);
  const [isExaminationLoading, setIsExaminationLoading] = useState(false);

  // Derived state
  const [subjectId, setSubjectId] = useState(null);

  const examModeOptions = [
    { value: "ONLINE", label: "Online" },
    { value: "OFFLINE", label: "Offline" },
  ];

  const prepareFormData = (data = null) => {
    return {
      examDate: data != null ? formatDateToYYYYMMDD(data["EXAM DATE"]) : "",
      startTime: data != null ? formatTimeToHHMM(data["START TIME"]) : "",
      examMode: {
        value: data != null ? data["EXAM MODE"] : "",
        label: data != null ? data["EXAM MODE"] : "",
      },
      examination: {
        value: data?.examinationId || data?._EXAMINATION || "",
        label: data?.examinationName || data?.EXAMINATION || "",
      },
    };
  };

  const [formData, setFormData] = useState(prepareFormData());

  // Get series subject details for editing
  const getSeriesSubjectDetails = async (subjectId) => {
    setLoadingData(true);
    try {
      console.log("data isss:", modal.data);
      setSubjectId(modal.data._SUBJECT);
      setData(modal.data);
      setFormData(prepareFormData(modal.data));
    } catch (error) {
      console.error("Error fetching series subject details:", error);
      showErrorMessages({
        data: { message: "Failed to fetch series subject details" },
        navigate,
      });
    }
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    if (field === "examination") {
      setSubjectId(value.subjectId);
    }

    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const getExaminationOptions = async () => {
    setIsExaminationLoading(true);
    try {
      const res = await getExamainationTemplatesList({
        status: "Approved",
        academicYearId: modal.data["_ACADEMIC YEAR"],
      });
      if (res.status === "success") {
        const list = res.data.entityList.map((item) => ({
          value: item._ID,
          label: item.NAME,
          subjectId: item._SUBJECT,
        }));
        setExaminationOptions(list);
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error fetching examinations:", error);
      showErrorMessages({
        data: { message: "Failed to fetch examinations" },
        navigate,
      });
    }
    setIsExaminationLoading(false);
  };

  const validateFields = () => {
    const newErrors = {};

    if (!formData.examDate?.trim()) {
      newErrors.examDate = "Exam date is required";
    }

    if (!formData.startTime?.trim()) {
      newErrors.startTime = "Start time is required";
    }

    if (!formData.examMode.value) {
      newErrors.examMode = "Exam mode is required";
    }

    if (!formData.examination.value) {
      newErrors.examination = "Examination template is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Date formatting utilities
  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Function to convert date and time from IST to UTC
  function convertDateTimeToUTC(dateString, timeString) {
    if (!dateString || !timeString) return { date: "", time: "" };

    // Convert time from HH:MM to 24-hour format if needed
    const time24 = formatTimeToHHMM(timeString);

    // Combine date and time in IST format
    const istDateTime = `${dateString}T${time24}:00+05:30`;

    // Create date object (automatically converts to UTC)
    const utcDate = new Date(istDateTime);

    // Extract UTC date in DD/MM/YYYY format
    const day = String(utcDate.getUTCDate()).padStart(2, "0");
    const month = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
    const year = utcDate.getUTCFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Extract UTC time in HH:MM AM/PM format
    const utcHours = utcDate.getUTCHours();
    const utcMinutes = utcDate.getUTCMinutes();

    // Convert to 12-hour format
    const hour12 =
      utcHours === 0 ? 12 : utcHours > 12 ? utcHours - 12 : utcHours;
    const ampm = utcHours >= 12 ? "PM" : "AM";
    const formattedTime = `${hour12.toString().padStart(2, "0")}:${utcMinutes
      .toString()
      .padStart(2, "0")} ${ampm}`;

    return {
      date: formattedDate,
      time: formattedTime,
    };
  }

  function formatDateToYYYYMMDD(dateString) {
    if (!dateString) return "";
    // If dateString is in DD/MM/YYYY format, convert to YYYY-MM-DD
    if (dateString.includes("/")) {
      const [day, month, year] = dateString.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    // If already in correct format or ISO date
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  }

  function formatTimeToHHMMA(timeString) {
    if (!timeString) return "";
    // Handle time input from HTML input type="time" (format: "HH:MM")
    const [hours, minutes] = timeString.split(":");
    const hour24 = parseInt(hours, 10);

    // Convert to 12-hour format
    const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
    const ampm = hour24 >= 12 ? "PM" : "AM";

    // Ensure 2-digit formatting for hour and minute
    const formattedHour = hour12.toString().padStart(2, "0");
    const formattedMinute = minutes.padStart(2, "0");

    return `${formattedHour}:${formattedMinute} ${ampm}`;
  }

  function formatTimeToHHMM(timeString) {
    if (!timeString) return "";
    // Convert from "HH:MM AM/PM" to "HH:MM" (24-hour format)
    if (timeString.includes("AM") || timeString.includes("PM")) {
      const [time, period] = timeString.split(" ");
      const [hours, minutes] = time.split(":");
      let hour24 = parseInt(hours, 10);

      if (period === "PM" && hour24 !== 12) {
        hour24 += 12;
      } else if (period === "AM" && hour24 === 12) {
        hour24 = 0;
      }

      return `${hour24.toString().padStart(2, "0")}:${minutes}`;
    }
    return timeString;
  }

  const submitForm = async () => {
    if (!validateFields()) return;

    setLoading(true);

    // Convert both date and time from IST to UTC
    const utcDateTime = convertDateTimeToUTC(
      formData.examDate,
      formData.startTime
    );

    const dataToSubmit = {
      id: modal.isEditing ? modal.data._ID : null,
      examDate: utcDateTime.date, // UTC date in DD/MM/YYYY format
      startTime: utcDateTime.time, // UTC time in HH:MM AM/PM format
      examMode: formData.examMode.value?.toLocaleUpperCase(),
      subjectId: subjectId,
      examinationId: formData.examination.value,
      regionId: modal.data._REGION || null,
      siteId: modal.data._SITE || null,
      seriesId: modal.data.seriesId || null,

      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
    };

    if (data) {
      dataToSubmit.id = data._ID;
    }

    try {
      const res = data
        ? await updateExaminationSeriesSubject(dataToSubmit, data._ID)
        : await addExaminationSeriesSubject(dataToSubmit);

      if (res.status === "success") {
        callToast(
          "success",
          data ? "Updated" : "Created",
          `Series Subject ${data ? "updated" : "added"} successfully`
        );
        await refresh({ columnRefresh: false, isLoading: false });
        dispatch(closeModal());
      } else {
        const resError = showErrorMessages({
          data: res,
          navigate,
        });

        if (resError != null && resError != undefined) {
          const error = {};
          Object.entries(resError).forEach(([key, value]) => {
            error[key] = value.message;
          });
          setErrors(error);
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      callToast("error", "Error", "Failed to submit series subject");
    }

    setLoading(false);
  };

  useEffect(() => {
    getExaminationOptions();

    // If editing, fetch the series subject details
    if (modal.isEditing && modal.data?._ID) {
      getSeriesSubjectDetails(modal.data._ID);
    }
  }, [modal.isEditing, modal.data]);

  if (loadingData) {
    return (
      <center>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </center>
    );
  }

  return (
    <section className="login-content">
      <div className="m-5 mt-1">
        <div className="d-flex">
          <div className="w-100">
            <form>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Exam Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.examDate}
                    onChange={(e) => handleChange("examDate", e.target.value)}
                  />
                  {errors.examDate && (
                    <small className="text-danger">{errors.examDate}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Start Time</label>
                  <input
                    type="time"
                    className="form-control"
                    value={formData.startTime}
                    onChange={(e) => handleChange("startTime", e.target.value)}
                  />
                  {errors.startTime && (
                    <small className="text-danger">{errors.startTime}</small>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Exam Mode</label>
                <Select
                  options={examModeOptions}
                  value={formData.examMode.label ? formData.examMode : null}
                  styles={selectStyle}
                  onChange={(newValue) =>
                    handleChange(
                      "examMode",
                      newValue || { value: "", label: "" }
                    )
                  }
                  placeholder="Select Exam Mode"
                  className="basic-single"
                  classNamePrefix="select"
                />
                {errors.examMode && (
                  <small className="text-danger">{errors.examMode}</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Examination Template</label>
                <Select
                  options={examinationOptions}
                  value={
                    formData.examination.label ? formData.examination : null
                  }
                  styles={selectStyle}
                  onChange={(newValue) =>
                    handleChange(
                      "examination",
                      newValue || { value: "", label: "" }
                    )
                  }
                  components={
                    isExaminationLoading ? { DropdownIndicator } : null
                  }
                  isSearchable={!isExaminationLoading}
                  placeholder="Select Examination Template"
                  className="basic-single"
                  classNamePrefix="select"
                />
                {errors.examination && (
                  <small className="text-danger">{errors.examination}</small>
                )}
              </div>

              <div className="d-flex justify-content-end mt-4 gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitForm}
                  disabled={loading}
                >
                  {loading ? (
                    <div className="spinner-border text-light" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        className="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default AddSeriesSubjectForm;
